import React from 'react';
import { Box, Text, useColorModeValue } from '@chakra-ui/react';

interface LogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'; // xs: 16px, sm: 20px, md: 28px, lg: 40px, xl: 56px
  showText?: boolean;
  variant?: 'default' | 'white' | 'simple';
  onClick?: () => void;
  clickable?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  showText = true, 
  variant = 'default',
  onClick,
  clickable = false
}) => {
  const sizes = {
    xs: { logo: 16, text: 'xs' }, // 移动端专用小尺寸
    sm: { logo: 20, text: 'sm' },
    md: { logo: 28, text: 'md' },
    lg: { logo: 40, text: 'lg' },
    xl: { logo: 56, text: 'xl' },
  };

  const currentSize = sizes[size];
  const textColor = useColorModeValue('brand.500', 'brand.200');

  const renderLogo = () => {
    if (variant === 'simple') {
      return (
        <Box
          w={currentSize.logo}
          h={currentSize.logo}
          bg="brand.500"
          borderRadius="full"
          display="flex"
          alignItems="center"
          justifyContent="center"
          color="white"
          fontWeight="bold"
          fontSize={size === 'xs' ? 'xs' : size === 'sm' ? 'xs' : size === 'md' ? 'sm' : 'md'}
        >
          D
        </Box>
      );
    }

    return (
      <Box
        w={currentSize.logo}
        h={currentSize.logo}
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {/* 外圈 */}
        <Box
          position="absolute"
          w="full"
          h="full"
          borderRadius="full"
          bgGradient="linear(to-br, brand.500, brand.600)"
          boxShadow="lg"
        />
        
        {/* 内圈 */}
        <Box
          position="absolute"
          w="85%"
          h="85%"
          borderRadius="full"
          bg="white"
          _dark={{ bg: 'gray.800' }}
        />
        
        {/* 中心圆圈 */}
        <Box
          position="absolute"
          w="70%"
          h="70%"
          borderRadius="full"
          border="2px solid"
          borderColor="brand.500"
        />
        
        {/* 美元符号 */}
        <Text
          position="absolute"
          fontSize={size === 'xs' ? 'xs' : size === 'sm' ? 'xs' : size === 'md' ? 'sm' : 'md'}
          fontWeight="bold"
          color="brand.500"
          zIndex={1}
        >
          $
        </Text>
      </Box>
    );
  };

  return (
    <Box 
      display="flex" 
      alignItems="center" 
      gap={2}
      onClick={onClick}
      cursor={clickable || onClick ? 'pointer' : 'default'}
      transition="opacity 0.2s"
      _hover={clickable || onClick ? { opacity: 0.8 } : {}}
    >
      {renderLogo()}
      {showText && (
        <Text
          fontSize={currentSize.text}
          fontWeight="bold"
          color={textColor}
          letterSpacing="tight"
        >
          DOR
        </Text>
      )}
    </Box>
  );
};

export default Logo; 